import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const CreditCard = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="credit card icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 8V9.5L23 9.5V8L1 8ZM1 7L23 7C23 5.89543 22.1046 5 21 5L3 5C1.89543 5 1 5.89543 1 7ZM1 17L1 10.5L23 10.5V17C23 18.1046 22.1046 19 21 19H3C1.89543 19 1 18.1046 1 17ZM0 17C0 18.6569 1.34315 20 3 20H21C22.6569 20 24 18.6569 24 17V7C24 5.34315 22.6569 4 21 4L3 4C1.34315 4 0 5.34315 0 7L0 17ZM10 13V14H4V13H10ZM4 16.5H7V15.5H4V16.5Z"
    />
  </svg>
)
